module.exports = __webpack_public_path__ + "assets/img/37_1611_big.4e71d6de.jpg";